module.exports = __webpack_public_path__ + "img/img36.88e4eb4f.png";